import { Plugin, ButtonView } from 'ckeditor5';

const trashIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
`;

export default class ClearButton extends Plugin {
    static get pluginName() {
        return 'ClearText';
    }
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('clearText', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Clear Text',
                icon: trashIcon,
                tooltip: true
            });

            view.on('execute', () => {
                const model = editor.model;
                model.change(writer => {
                    const root = model.document.getRoot();
                    for (const child of Array.from(root.getChildren())) {
                        writer.remove(child);
                    }
                });
            });

            return view;
        });
    }
}
